import { render, staticRenderFns } from "./RateAdjustments.vue?vue&type=template&id=108acf66&"
import script from "./RateAdjustments.vue?vue&type=script&lang=ts&"
export * from "./RateAdjustments.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports